import React, { createContext, useContext, useReducer } from 'react';
import { Modal, ModalBody } from "reactstrap";

export const Types = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE'
}

const initialState = {
  data: []
}


const ModalStateContext = createContext({
  state: initialState,
  dispatch: () => null
});

function userReducer(state, action) {
  switch (action.type) {
    case Types.OPEN: {
      const data = [...state.data];
      data.push(action.item)
      return {
        data
      }
    }
    case Types.CLOSE: {
      const data = [...state.data].filter(e => e.id !== action.item.id);

      return {
        data
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export const ModalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialState);

  return (
    <ModalStateContext.Provider value={{ state, dispatch }}>
      {children}
    </ModalStateContext.Provider>
  )
}

export const useModal = () => useContext(ModalStateContext);

export const ModalContainer = () => {
  const { state: { data }, dispatch } = useModal();
  return <>
    {data.map(modal =>
      <Modal key={modal.id} isOpen={true} toggle={() => dispatch({
        type: Types.CLOSE,
        item: {
          id: modal.id
        }
      })} {...modal.configModal}>
        <ModalBody {...modal.configModalBody}>
          {modal.content}
        </ModalBody>
      </Modal>
    )}
  </>
}